export default __webpack_public_path__ + "static/media/caleb-levels-icon.6f00fb3c.svg";